import React, { useCallback, useState } from 'react';

import {
    AttachmentSelector as DefaultAttachmentSelector,
    SimpleAttachmentSelector,
    useMessageComposerHasSendableData,
  } from 'stream-chat-react';
  import { AttachmentPreviewList as DefaultAttachmentPreviewList } from 'stream-chat-react';
  import { CooldownTimer as DefaultCooldownTimer } from 'stream-chat-react';
  import { SendButton as DefaultSendButton } from 'stream-chat-react';
  import {
    AudioRecorder as DefaultAudioRecorder,
    RecordingPermissionDeniedNotification as DefaultRecordingPermissionDeniedNotification,
    StartRecordingAudioButton as DefaultStartRecordingAudioButton,
    RecordingPermission,
  } from 'stream-chat-react';
  import {
    QuotedMessagePreview as DefaultQuotedMessagePreview,
    QuotedMessagePreviewHeader,
  } from 'stream-chat-react';
  import { LinkPreviewList as DefaultLinkPreviewList } from 'stream-chat-react';
  import { TextareaComposer as DefaultTextareaComposer } from 'stream-chat-react';
  
  import { useMessageInputContext } from 'stream-chat-react';
  import { useComponentContext } from 'stream-chat-react';
  import { useAttachmentManagerState } from 'stream-chat-react';
  import { useMessageContext } from 'stream-chat-react';
  import { WithDragAndDropUpload } from 'stream-chat-react';
import { useTheme } from '../../../hooks/useTheme';

export const CustomMessageInputFlat = () => {
  const { message } = useMessageContext();
  const {
    asyncMessagesMultiSendEnabled,
    cooldownRemaining,
    handleSubmit,
    hideSendButton,
    recordingController,
    setCooldownRemaining,
  } = useMessageInputContext('MessageInputFlat');
  const { isMobile } = useTheme();

  const {
    AttachmentPreviewList = DefaultAttachmentPreviewList,
    AttachmentSelector = message ? SimpleAttachmentSelector : DefaultAttachmentSelector,
    AudioRecorder = DefaultAudioRecorder,
    CooldownTimer = DefaultCooldownTimer,
    EmojiPicker,
    LinkPreviewList = DefaultLinkPreviewList,
    QuotedMessagePreview = DefaultQuotedMessagePreview,
    RecordingPermissionDeniedNotification = DefaultRecordingPermissionDeniedNotification,
    SendButton = DefaultSendButton,
    StartRecordingAudioButton = DefaultStartRecordingAudioButton,
    TextareaComposer = DefaultTextareaComposer,
  } = useComponentContext();

  const hasSendableData = useMessageComposerHasSendableData();

  const [
    showRecordingPermissionDeniedNotification,
    setShowRecordingPermissionDeniedNotification,
  ] = useState(false);
  const closePermissionDeniedNotification = useCallback(() => {
    setShowRecordingPermissionDeniedNotification(false);
  }, []);

  const { attachments } = useAttachmentManagerState();

  if (recordingController.recordingState) return <AudioRecorder />;

  const recordingEnabled = !!(recordingController.recorder && navigator.mediaDevices); // account for requirement on iOS as per this bug report: https://bugs.webkit.org/show_bug.cgi?id=252303
  const isRecording = !!recordingController.recordingState;

  return (
    <WithDragAndDropUpload className='str-chat__message-input' component='div'>
      {recordingEnabled &&
        recordingController.permissionState === 'denied' &&
        showRecordingPermissionDeniedNotification && (
          <RecordingPermissionDeniedNotification
            onClose={closePermissionDeniedNotification}
            permissionName={RecordingPermission.MIC}
          />
        )}
      <LinkPreviewList />
      <QuotedMessagePreviewHeader />

      <div className='str-chat__message-input-inner'>
        <AttachmentSelector />
        <div className='str-chat__message-textarea-container'>
          <QuotedMessagePreview />
          <AttachmentPreviewList />
          <div className='str-chat__message-textarea-with-emoji-picker'>
            <TextareaComposer 
              shouldSubmit={(event: React.KeyboardEvent<HTMLTextAreaElement>) => {
                if (event.key === 'Enter') {
                  if (event.shiftKey || isMobile) {
                    return false;
                  }
                  return true;
                }
                return false;
              }}
            />
            {EmojiPicker && <EmojiPicker />}
          </div>
        </div>
        {!hideSendButton && (
            <>
                {cooldownRemaining ? (
                    <CooldownTimer
                        cooldownInterval={cooldownRemaining}
                        setCooldownRemaining={setCooldownRemaining}
                    />
                    ) : (
                    <>
                    {
                        hasSendableData ? (
                            <SendButton sendMessage={handleSubmit} />
                        ) : (
                            recordingEnabled && (
                                <StartRecordingAudioButton
                                  disabled={
                                    isRecording ||
                                    (!asyncMessagesMultiSendEnabled &&
                                      attachments.some(
                                        (a) => a.type === 'voiceRecording',
                                      ))
                                  }
                                  onClick={() => {
                                    recordingController.recorder?.start();
                                    setShowRecordingPermissionDeniedNotification(true);
                                  }}
                                />
                              )
                        )
                    }
                </>
                )}
            </>
        )
      }
      </div>
    </WithDragAndDropUpload>
  );
};